import { dateHeader, formatCellDate } from './timeModeCell';
import { linkTo } from '../linkTo';
import CellTowerIcon from '@mui/icons-material/CellTower';
import AnchorIcon from '@mui/icons-material/Anchor';
import SatelliteAltOutlinedIcon from '@mui/icons-material/SatelliteAltOutlined';
import { LocationMehod } from '../../constants/Constants';
import { secondsToDhms } from '../../utils/index';

export const makeReportListColumn = () => {
  const renderLocationMethod = (locationMethod) => {
    return locationMethod === LocationMehod.GPS ? (
      <SatelliteAltOutlinedIcon style={{ color: 'green', fontSize: '1.1rem' }} />
    ) : locationMethod === LocationMehod.NETWORK ? (
      <CellTowerIcon style={{ color: 'blue', fontSize: '1.1rem' }} />
    ) : locationMethod === LocationMehod.ANCHOR_TAG ? (
      <AnchorIcon style={{ color: 'red', fontSize: '1.1rem' }} />
    ) : (
      <></>
    );
  };

  const col = [
    {
      header: 'Imei',
      accessorKey: 'imei',
      headerClassName: 'react-table-header-align-center',
      enableColumnFilter: true,
      size: 60,
      style: { textAlign: 'center' },
      cell: ({ row }) => linkTo('/report', row.original.reportId, 'detail'),
    },
    {
      header: dateHeader('Last Seen'),
      accessorKey: 'lastSeenDateTime',
      enableColumnFilter: true,
      size: 100,
      cell: ({ row, table }) => formatCellDate(table, row.original.lastSeenDateTime),
    },
    {
      header: 'IsMobile',
      accessorKey: 'isMobile',
      enableColumnFilter: true,
      size: 60,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        return row.original.isMobile ? 'Yes' : 'No';
      },
    },
    {
      header: 'Location',
      accessorKey: 'stationIataCode',
      enableColumnFilter: true,
      size: 60,
      style: { textAlign: 'center' },
    },
    {
      header: 'Method',
      accessorKey: 'locationMethod',
      enableColumnFilter: true,
      size: 56,
      style: { textAlign: 'center' },
      cell: ({ row }) => <span title={row.original.locationMethodDescr}>{renderLocationMethod(row.original.locationMethod)}</span>,
    },
    {
      header: 'Interval',
      accessorKey: 'reportInterval',
      enableColumnFilter: true,
      size: 56,
      style: { textAlign: 'center' },
      cell: ({ row }) => <span> {secondsToDhms(row.original.reportInterval)}</span>,
    },
    {
      header: 'Battery %',
      accessorKey: 'batteryPercent',
      enableColumnFilter: false,
      size: 70,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        const percentage = row.original.batteryPercent ?? 0;
        const color = percentage >= 80 ? 'green' : percentage <= 20 ? 'red' : percentage <= 30 ? 'orange' : '';
        return <span style={{ color: color }}>{percentage}%</span>;
      },
    },
    {
      header: 'On Premise',
      accessorKey: 'isOnAirport',
      enableColumnFilter: true,
      size: 80,
      cell: ({ row }) => (row.original.isOnAirport ? 'True' : 'False'),
      style: { textAlign: 'center' },
    },
    {
      header: 'Latitude',
      accessorKey: 'location.latitude',
      disableSortBy: true,
      enableColumnFilter: true,
      size: 100,
    },
    {
      header: 'Longitude',
      accessorKey: 'location.longitude',
      disableSortBy: true,
      enableColumnFilter: true,
      size: 100,
    },
    {
      header: 'Processed Sightings',
      accessorKey: 'processedCount',
      enableColumnFilter: true,
      size: 80,
      style: { textAlign: 'center' },
      cell: ({ row }) => row.original.processedCount ?? 0,
    },
    {
      header: 'Total Sightings',
      accessorKey: 'sightingCount',
      enableColumnFilter: true,
      size: 80,
      style: { textAlign: 'center' },
      cell: ({ row }) => row.original.sightingCount ?? 0,
    },
    {
      header: 'Status',
      accessorKey: 'status',
      enableColumnFilter: true,
      size: 70,
      cell: ({ row }) => row.original.statusDescr,
    },
    {
      header: dateHeader('Time of Report'),
      accessorKey: 'reportedDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.reportedDateTime),
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 'auto',
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
  ] as Array<any>;

  return col;
};
